import React from 'react';

import { ProductName } from '../product-name';
import Rating from 'src/components/rating';

import { BaseProps } from '../../types';
import { CountTranslation } from 'src/components/rating/types';

const RATING_TRANSLATION = {
  domain: 'product',
  key: 'product-card.n-ratings',
} as CountTranslation;

type Props = Pick<
  BaseProps,
  'name' | 'rating' | 'highlightedName' | 'reviewsCount' | 'ratingScale'
>;

export const CompactListCardProductContent: React.FC<Props> = props => {
  const { name, rating, highlightedName, reviewsCount, ratingScale } = props;

  return (
    <div>
      <ProductName>{highlightedName || name}</ProductName>

      {rating && rating > 0 ? (
        <Rating
          rate={rating}
          singleStar
          showRate
          showCounter
          count={reviewsCount}
          countTranslation={RATING_TRANSLATION}
          size="small"
          ratingScale={ratingScale}
        />
      ) : null}
    </div>
  );
};
